import { Box, BoxProps } from '@chakra-ui/react';

type Props = BoxProps & unknown;

export const AccountContainer = ({ ...boxProps }: Props) => (
  <Box
    mt={{ base: 'space.12', md: 'space.32' }}
    mb={{
      base: 'space.48',
      md: 'space.64',
    }}
    {...boxProps}
  />
);
